import { render } from "./StockLevelZeroView.vue?vue&type=template&id=4dba54a3&scoped=true"
import script from "./StockLevelZeroView.vue?vue&type=script&lang=js"
export * from "./StockLevelZeroView.vue?vue&type=script&lang=js"

import "./StockLevelZeroView.vue?vue&type=style&index=0&id=4dba54a3&scoped=true&lang=css"

import exportComponent from "/Users/chrisfinlayson/Desktop/WORK/riverhawk-nest/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dba54a3"]])

export default __exports__